import { cn } from '../../lib/cn';
import type { InsightRow } from '../../executiveintel/framework';

type Props = { insights?: InsightRow[] };

function severityColor(severity: string) {
  switch (severity) {
    case 'critical': return 'border-error-200 bg-error-50 dark:border-error-900 dark:bg-error-950';
    case 'high': return 'border-warning-200 bg-warning-50 dark:border-warning-900 dark:bg-warning-950';
    case 'opportunity': return 'border-success-200 bg-success-50 dark:border-success-900 dark:bg-success-950';
    default: return 'border-slate-200 dark:border-slate-700';
  }
}

export function AIInsightEnginePanel({ insights = [] }: Props) {
  return (
    <div className="space-y-2">
      {insights.map((i) => (
        <div key={i.title} className={cn('rounded-lg border p-3', severityColor(i.severity))}>
          <span className="text-xs font-medium text-slate-500">{i.type}</span>
          <p className="mt-0.5 text-sm font-medium">{i.title}</p>
          <p className="mt-0.5 text-xs capitalize text-slate-500">{i.severity}</p>
        </div>
      ))}
    </div>
  );
}
